import { ThunkDispatch } from '@reduxjs/toolkit'
import { IState } from 'legacy/lut/store'
import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'

type TypedDispatch<T> = ThunkDispatch<T, unknown, AnyAction>

export type TAppDispatch = TypedDispatch<IState>

export const useAppDispatch = () => useDispatch<TAppDispatch>()
